module.exports = __webpack_public_path__ + "static/media/FrameCollection2.f67aec24.png";